import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function downloadCompanyFiles(
  companyId: string,
  fileIds: string[],
  auth: Authentication | null
): Promise<{ url: string; filename: string }> {
  try {
    if (!auth) throw new DownloadCompanyFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const { blob, filename } = await HttpClient.postBlob(
      `/backoffice/companies/${companyId}/files/multiple`,
      { fileIds },
      auth.token
    );

    return { url: URL.createObjectURL(blob), filename: filename || 'fichiers.zip' };
  } catch (e) {
    if (e instanceof DownloadCompanyFilesFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new DownloadCompanyFilesFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class DownloadCompanyFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default downloadCompanyFiles;
